export default __webpack_public_path__ + "static/media/mouse left click.5c65903e.svg";